import BasePointManager from "../../../../../src/managers/BasePointManager";
import { Coord } from "../../../../../src/types/Interface";
import { CIRCLE_RADIUS, INITIAL_RADIANS } from "../types/Config";
import { eventBus, EnumEventBus } from "./EventBus";


export default class PointManager extends BasePointManager {
  private pointCheckList: Boolean[] = [false, false];

  constructor(cCoord: Coord) {
    super(cCoord, CIRCLE_RADIUS, INITIAL_RADIANS);
    this.setCoord();
    this.draw();
    eventBus.on(EnumEventBus.setPointChecklist, l => this.pointCheckList = l);
    eventBus.on(EnumEventBus.moveCircumPoints, (v: number) => this.moveCircumPoints(v))
    eventBus.on(EnumEventBus.moveAllPoints, (v: number) => this.moveAllPoints(v));
    eventBus.on(EnumEventBus.setRefPoints, () => this.pointRefRadians = [...this.pointRadians])
  }
  moveAllPoints(v: number) {
    const points = this.getRedPoints();
    const pointInfoArr = this.getRefRadians().map((ref, refI) => ({ pTag: points[refI].tag, radian: ref + v / 100 * (Math.PI / 3) }));
    this.setRadian(pointInfoArr, true)
  }
  moveCircumPoints(v: number) {
    const points = this.getRedPoints();
    const generateOffsetRadian = (v: number) => (Math.PI / 300) * v;
    const pointInfoArr = this.pointCheckList
      .map((e, eI) => this.pointRefRadians[eI] + (e ? generateOffsetRadian(v) : 0))
      .map((r, rI) => ({ pTag: points[rI].tag, radian: r }));
    this.setRadian(pointInfoArr, true)
  }
}
